export const FormatterMode = {
    Text: "text",
    Web: "web",
    Ecommerce: "ecommerce",
};
export const FORMATTER_MODE_VALUES = Object.values(FormatterMode);
export function isFormatterMode(value) {
    return typeof value === "string" && FORMATTER_MODE_VALUES.includes(value);
}
export function parseFormatterMode(value, fallback = FormatterMode.Text) {
    return isFormatterMode(value) ? value : fallback;
}
